module.exports = __webpack_public_path__ + "static/media/speakout.cae0e547.JPG";